import { inject } from '@angular/core';
import { ApiService } from '../services/communications/api.service';
import { UserDataService } from '../services/userData.service';
import { SignalRService } from '../services/communications/signalr.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

export const UserDataResolver = async () => {
  const apiService = inject(ApiService);
  const userDataService = inject(UserDataService);
  const signalRService = inject(SignalRService);

  await signalRService.ensureConnected();

  try {
    console.log('Start getAssetInfo...');

    const assetInfo = await firstValueFrom(apiService.getAssetInfo(userDataService.AssetId!, userDataService.Id!, userDataService.AssistanceToOpen!));
    console.log('Finish getAssetInfo: ', assetInfo);

    return assetInfo;
   
  } catch (error) {
    console.error('Error getAssetInfo:', error);
    return null;
  }
};
